import React, { useContext, useEffect, useState, useRef } from "react";
import { Grid, ListItem, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { FixedSizeList } from "react-window";
import moment from "moment";

// Contexts
import DiscountContext from "../../../context/discounts/DiscountContext";

// Components
import Form from "./content/Form";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 460,
  },
  grid: {
    height: "100%",
  },
  list: {
    width: "100%",
    height: "100%",
    minHeight: 364,
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    overflow: "auto",
    border: "1px solid silver",
    borderRadius: "5px",
    marginBottom: "1rem",
  },
}));

const DiscountDisplay = ({ onChangePage }) => {
  const classes = useStyles();

  const {
    display_content,
    discounts,
    discounts_filtered,
    selected_discount,
    form_data,
    form_error,
    setFormData,
    setFormError,
  } = useContext(DiscountContext);

  const listRef = useRef("");
  const [discount_list, setDiscountList] = useState([]);

  useEffect(() => {
    // Create Discount List For Display
    if (discounts_filtered) setDiscountList(discounts_filtered);
    else setDiscountList(discounts);
  }, [discounts, discounts_filtered]);

  useEffect(() => {
    // Auto Focus List Item on Selected Discount
    if (
      discount_list.length > 0 &&
      selected_discount &&
      selected_discount.discount_name
    ) {
      const search = (discount_list) =>
        discount_list.discount_name === selected_discount.discount_name;

      listRef.current.scrollToItem(discount_list.findIndex(search), "smart");
    }
  }, [selected_discount, discount_list]);

  const handleChange = (e) => {
    const id = e.target.id;
    let value = e.target.value;

    if (id === "discount_name") {
      value = value.toUpperCase().replace(/ /g, "");
    }

    form_data[id] = value;

    // Regex
    const validPricing = /^[0-9]{1,}\.{0,1}[0-9]*$/;

    switch (id) {
      case "discount_name":
        if (value.length < 1) {
          form_error[id] = "Discount Code cannot be empty!";
        } else if (value.length > 20) {
          form_error[id] = "Discount Code cannot be more than 20 characters!";
        } else {
          form_error[id] = "";
        }
        break;

      case "discount_amount":
      case "spend_threshold":
        const field_name =
          id === "discount_amount" ? "Discount Amount" : "Spend Threshold";

        if (value.length < 1) {
          form_error[id] = `${field_name} cannot be empty!`;
        } else {
          if (!validPricing.test(value)) {
            form_error[id] = `${field_name} must be a numeric value!`;
          } else {
            form_error[id] = "";
          }
        }
        break;

      default:
        break;
    }

    setFormData(form_data);
    setFormError(form_error);
  };

  const handleDateChange = (type, date) => {
    date = moment(date).format("YYYY-MM-DD");

    if (type === "start") form_data["discount_startdate"] = date;
    if (type === "expire") form_data["discount_expiredate"] = date;

    const start = form_data.discount_startdate;
    const expire = form_data.discount_expiredate;

    if (start >= expire) {
      form_error["discount_startdate"] =
        "Start Date cannot be the same or after expire date.";
      form_error["discount_expiredate"] =
        "Expire Date must be AFTER start date.";
    } else {
      form_error["discount_startdate"] = "";
      form_error["discount_expiredate"] = "";
    }

    setFormData(form_data);
    setFormError(form_error);
  };

  // List Item
  const renderListItem = ({ index, style, data }) => {
    const each = data[index];

    return (
      <ListItem
        key={index}
        style={style}
        button
        selected={
          selected_discount &&
          selected_discount.discount_name === each.discount_name
        }
        onClick={() => onChangePage(each.discount_name)}
      >
        <ListItemText secondary={each.discount_name} />{" "}
      </ListItem>
    );
  };

  return (
    <Grid item xs={12} container direction="column">
      <Grid item container className={classes.root}>
        {" "}
        {/* Discount List */}{" "}
        <Grid
          item
          xs={2}
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          className={classes.grid}
        >
          <div className={classes.list}>
            {" "}
            {discount_list.length > 0 && (
              <FixedSizeList
                width="100%"
                height={450}
                itemSize={30}
                itemCount={discount_list.length}
                itemData={discount_list}
                ref={listRef}
              >
                {renderListItem}{" "}
              </FixedSizeList>
            )}{" "}
          </div>{" "}
        </Grid>
        {/* Form */}{" "}
        <Grid
          item
          xs={10}
          container
          justifyContent="center"
          alignItems="flex-start"
          className={classes.grid}
        >
          <Grid item xs={12} className={classes.grid}>
            {" "}
            {display_content === "" && <div />}{" "}
            {display_content === "Create" && (
              <Form
                formType="Create"
                handleChange={handleChange}
                handleDateChange={handleDateChange}
              />
            )}{" "}
            {display_content === "Edit" && selected_discount && (
              <Form
                formType="Edit"
                handleChange={handleChange}
                handleDateChange={handleDateChange}
              />
            )}{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Grid>{" "}
    </Grid>
  );
};

export default DiscountDisplay;
